import config from '@/config';
import { DeviceType } from '@/logic/main/types';
import { fetchData } from '@/model/utils/fetch';
import {
  getGamesFromStorage,
  isHtml5StorageSupported,
} from '@/model/utils/recommendedGamesStorage';

const fecthGames = async ({
  authToken,
  device_type,
  title,
  locale,
  market_country,
  market_region,
  limit,
}: {
  authToken: string;
  device_type: DeviceType;
  title: string;
  locale?: string;
  market_country?: string;
  market_region?: string;
  limit?: number;
}) => {
  const response = await fetchData<{
    [key: string]: any;
  }>({
    url: `${config.urls.bffBaseUrl}/recommended-games-by-account-id`,
    headers: { authorization: `Bearer ${authToken}` },
    queryParameters: {
      device_type,
      title,
      market_country,
      market_region,
      locale,
      base_path: config.base_path,
      limit,
    },
  });

  return {
    status: 200,
    data: response.games,
  };
};

export const fetchRecommendedGamesByAccountID = async ({
  authToken,
  device_type,
  title,
  locale,
  market_country,
  market_region,
  limit,
}: {
  authToken: string;
  device_type: DeviceType;
  title: string;
  locale?: string;
  market_country?: string;
  market_region?: string;
  limit?: number;
}) => {
  const isLocalStorageSupported = isHtml5StorageSupported();

  try {
    // if localStorage is not supported always fetch games from DG
    if (!isLocalStorageSupported) {
      const response = await fecthGames({
        authToken,
        device_type,
        title,
        locale,
        market_country,
        market_region,
        limit,
      });

      return {
        status: 200,
        data: response.data,
      };
    }

    const gamesFromLocalStorage = getGamesFromStorage(
      'recommendedGamesByAccountID'
    );

    if (!gamesFromLocalStorage || !gamesFromLocalStorage.length) {
      const response = await fecthGames({
        authToken,
        device_type,
        title,
        locale,
        market_country,
        market_region,
        limit,
      });

      const storageObject = {
        games: response.data,
        timestamp: Date.now() + 15 * 60 * 1000, // store games in local storage for 15 minutes
      };
      localStorage.setItem(
        'recommendedGamesByAccountID',
        JSON.stringify(storageObject)
      );

      return {
        status: 200,
        data: response.data,
      };
    } else {
      return {
        status: 200,
        data: gamesFromLocalStorage,
      };
    }
  } catch (err) {
    console.error(
      `There was a problem while fetching Recommended games. ${config.urls.bffBaseUrl}/recommended-games-by-account-id`
    );
    console.error(err);

    return {
      // @ts-ignore
      status: err.status,
      data: [],
    };
  }
};
